import { createAction } from '@reduxjs/toolkit';

export const ON_CONNECT_ACTION_TYPE = 'saga/onConnect';
export const onConnectAction = createAction(ON_CONNECT_ACTION_TYPE);
